import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  getDailyActiveUsersCount,
  getMonthlyActiveUsers,
  getWeeklyActiveUsers,
  getUserActiveRetentionAfterFirstSession,
  getActiveUserCount,
  getActiveUsersHourlyBreakdown,
  getContentTypeCount,
  getMinutesListendToday,
  getMostRatedContent,
  getTopContent,
  getuserDetailedRetuntionAfterRegistration,
} from './thunks';
import { ContentAnalysisState } from './types';

export const name = 'contentAnalysis';

const initialState: ContentAnalysisState = {
  weeklyActiveReadersData: [],
  monthlyActiveReadersData: [],
  dailyActiveUsersCount: [],
  userActiveRetentionAfterFirstSession: [],
  activeUsersCount: 0,
  activeUsrsHourlyBreakdown: [],
  contentTypeCount: 0,
  minutesListendToday: 0,
  mostRatedContent: null,
  topContent: null,
  userDetailedRetuntion: [],
  mostPopularContent: [],
  weeklyActiveReadersStatus: 'idle',
  monthlyActiveReadersStatus: 'idle',
  dailyActiveUsersCountStatus: 'idle',
  userActiveRetentionAfterFirstSessionStatus: 'idle',
  activeUsersCountStatus: 'idle',
  activeUsrsHourlyBreakdownStatus: 'idle',
  contentTypeCountStatus: 'idle',
  minutesListendTodayStatus: 'idle',
  mostRatedContentStatus: 'idle',
  topContentStatus: 'idle',
  mostPopularContentStatus: 'idle',
  userDetailedRetuntionStatus: 'idle',
};
export const getDailyActiveUsersCountAsync = createAsyncThunk(
  name + '/getDailyActiveUsersCount',
  getDailyActiveUsersCount
);

export const getMonthlyActiveUsersAsync = createAsyncThunk(
  name + '/getMonthlyActiveUsers',
  getMonthlyActiveUsers
);

export const getWeeklyActiveUsersAsync = createAsyncThunk(
  name + '/getWeeklyActiveUsers',
  getWeeklyActiveUsers
);

export const getUserActiveRetentionAfterFirstSessionAsync = createAsyncThunk(
  name + '/getUserActiveRetentionAfterFirstSession',
  getUserActiveRetentionAfterFirstSession
);

export const getActiveUserCountAsync = createAsyncThunk(
  name + '/getActiveUserCount',
  getActiveUserCount
);

export const getActiveUsersHourlyBreakdownAsync = createAsyncThunk(
  name + '/getActiveUsersHourlyBreakdown',
  getActiveUsersHourlyBreakdown
);

export const getContentTypeCountAsync = createAsyncThunk(
  name + '/getContentTypeCount',
  getContentTypeCount
);

export const getMinutesListendTodayAsync = createAsyncThunk(
  name + '/getMinutesListendToday',
  getMinutesListendToday
);

export const getMostRatedContentAsync = createAsyncThunk(
  name + '/getMostRatedContent',
  getMostRatedContent
);

export const getTopContentAsync = createAsyncThunk(
  name + '/getTopContent',
  getTopContent
);

export const getuserDetailedRetuntionAfterRegistrationAsync = createAsyncThunk(
  name + '/getuserDetailedRetuntionAfterRegistration',
  getuserDetailedRetuntionAfterRegistration
);
export const slice = createSlice({
  name: name,
  initialState,
  reducers: {
    clear: (_) => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDailyActiveUsersCountAsync.pending, (state) => {
        state.dailyActiveUsersCountStatus = 'loading';
      })
      .addCase(getDailyActiveUsersCountAsync.fulfilled, (state, action) => {
        state.dailyActiveUsersCountStatus = 'idle';
        state.dailyActiveUsersCount = action.payload;
      })
      .addCase(getDailyActiveUsersCountAsync.rejected, (state, action) => {
        state.dailyActiveUsersCountStatus = 'failed';
      })
      .addCase(getMonthlyActiveUsersAsync.pending, (state) => {
        state.monthlyActiveReadersStatus = 'loading';
      })
      .addCase(getMonthlyActiveUsersAsync.fulfilled, (state, action) => {
        state.monthlyActiveReadersStatus = 'idle';
        state.monthlyActiveReadersData = action.payload;
      })
      .addCase(getMonthlyActiveUsersAsync.rejected, (state, action) => {
        state.monthlyActiveReadersStatus = 'failed';
      })
      .addCase(getWeeklyActiveUsersAsync.pending, (state) => {
        state.weeklyActiveReadersStatus = 'loading';
      })
      .addCase(getWeeklyActiveUsersAsync.fulfilled, (state, action) => {
        state.weeklyActiveReadersStatus = 'idle';
        state.weeklyActiveReadersData = action.payload;
      })
      .addCase(getWeeklyActiveUsersAsync.rejected, (state, action) => {
        state.weeklyActiveReadersStatus = 'failed';
      })
      .addCase(
        getUserActiveRetentionAfterFirstSessionAsync.pending,
        (state) => {
          state.userActiveRetentionAfterFirstSessionStatus = 'loading';
        }
      )
      .addCase(
        getUserActiveRetentionAfterFirstSessionAsync.fulfilled,
        (state, action) => {
          state.userActiveRetentionAfterFirstSessionStatus = 'idle';
          state.userActiveRetentionAfterFirstSession = action.payload;
        }
      )
      .addCase(
        getUserActiveRetentionAfterFirstSessionAsync.rejected,
        (state, action) => {
          state.userActiveRetentionAfterFirstSessionStatus = 'failed';
        }
      )
      .addCase(getActiveUserCountAsync.pending, (state) => {
        state.activeUsersCountStatus = 'loading';
      })
      .addCase(getActiveUserCountAsync.fulfilled, (state, action) => {
        state.activeUsersCountStatus = 'idle';
        state.activeUsersCount = action.payload;
      })
      .addCase(getActiveUserCountAsync.rejected, (state, action) => {
        state.activeUsersCountStatus = 'failed';
      })
      .addCase(getActiveUsersHourlyBreakdownAsync.pending, (state) => {
        state.activeUsrsHourlyBreakdownStatus = 'loading';
      })
      .addCase(
        getActiveUsersHourlyBreakdownAsync.fulfilled,
        (state, action) => {
          state.activeUsrsHourlyBreakdownStatus = 'idle';
          state.activeUsrsHourlyBreakdown = action.payload;
        }
      )
      .addCase(getActiveUsersHourlyBreakdownAsync.rejected, (state, action) => {
        state.activeUsrsHourlyBreakdownStatus = 'failed';
      })
      .addCase(getContentTypeCountAsync.pending, (state) => {
        state.contentTypeCountStatus = 'loading';
      })
      .addCase(getContentTypeCountAsync.fulfilled, (state, action) => {
        state.contentTypeCountStatus = 'idle';
        state.contentTypeCount = action.payload;
      })
      .addCase(getContentTypeCountAsync.rejected, (state, action) => {
        state.contentTypeCountStatus = 'failed';
      })
      .addCase(getMinutesListendTodayAsync.pending, (state) => {
        state.minutesListendTodayStatus = 'loading';
      })
      .addCase(getMinutesListendTodayAsync.fulfilled, (state, action) => {
        state.minutesListendTodayStatus = 'idle';
        state.minutesListendToday = action.payload;
      })

      .addCase(getMinutesListendTodayAsync.rejected, (state, action) => {
        state.minutesListendTodayStatus = 'failed';
      })
      .addCase(getMostRatedContentAsync.pending, (state) => {
        state.mostRatedContentStatus = 'loading';
      })
      .addCase(getMostRatedContentAsync.fulfilled, (state, action) => {
        state.mostRatedContentStatus = 'idle';
        state.mostRatedContent = action.payload;
      })
      .addCase(getMostRatedContentAsync.rejected, (state, action) => {
        state.mostRatedContentStatus = 'failed';
      })
      .addCase(getTopContentAsync.pending, (state) => {
        state.topContentStatus = 'loading';
      })
      .addCase(getTopContentAsync.fulfilled, (state, action) => {
        state.topContentStatus = 'idle';
        state.topContent = action.payload;
      })
      .addCase(getTopContentAsync.rejected, (state, action) => {
        state.topContentStatus = 'failed';
      })
      .addCase(
        getuserDetailedRetuntionAfterRegistrationAsync.pending,
        (state) => {
          state.userDetailedRetuntionStatus = 'loading';
        }
      )
      .addCase(
        getuserDetailedRetuntionAfterRegistrationAsync.fulfilled,
        (state, action) => {
          state.userDetailedRetuntionStatus = 'idle';
          state.userDetailedRetuntion = action.payload;
        }
      )
      .addCase(
        getuserDetailedRetuntionAfterRegistrationAsync.rejected,
        (state, action) => {
          state.userDetailedRetuntionStatus = 'failed';
        }
      );
  },
});

export const actions = slice.actions;

export default slice.reducer;
